import { AnswerPathTreeNode } from '@zinnia/form-engine-sdk';

import { NodeIds } from '../../nodeIds';

export const previousName: AnswerPathTreeNode = {
  path: 'previousName',
  children: [
    { path: 'firstName', nodeId: NodeIds.previousFirstName },
    { path: 'middleName', nodeId: NodeIds.previousMiddleName },
    { path: 'lastName', nodeId: NodeIds.previousLastName },
    { path: 'hasChangedName', nodeId: NodeIds.insuredHasChangedName },
  ],
};
